export const setNavbarTooltipPosition = function setNavbarTooltipPosition (params) {
  const el = this
  const tooltip = el.lookup('NavbarTooltip')
  if (!tooltip || !tooltip.node) return

  const node = tooltip.node

  if (!params || !params.visible) {
    node.style.opacity = '0'
    node.style.visibility = 'hidden'
    node.style.transform = 'translate3d(-50%,-10%,0)'
    return
  }

  const titleVal = typeof el.title === 'function' ? el.title(el, el.state) : el.title
  const title = titleVal || ''

  if (tooltip.P && tooltip.P.node) {
    tooltip.P.node.textContent = title
  }

  const btnRect = el.node.getBoundingClientRect()
  const parentRect = tooltip.parent.node.getBoundingClientRect()
  const left = btnRect.left - parentRect.left + (btnRect.width / 2)

  node.style.left = left + 'px'
  node.style.opacity = '1'
  node.style.visibility = 'visible'
  node.style.transform = 'translate3d(-50%,0,0)'
}
